import { constructEnum } from '@/lib/enum';

export default constructEnum('AuthorGrade', {
  NONMEMBER: 5,
  USER: 10,
  BEST_REVIEWER: 20,
  OPERATOR: 30
});
